import React, { useState } from "react";
import axios from "axios";
import "./App.css";
let ifr;

function App() {
  const [templateData, setTemplateData] = useState({ width: 1, height: 1 });
  const [size, setSize] = useState({});
  const previewUrl =
    "https://template.files.bycape.io/production/designer/index.html";

  // Check if path is acceptance
  let isAcceptance = window.location.hostname.includes("acceptance");
  const api =
    "https://api" +
    (isAcceptance ? "-acceptance" : "") +
    ".campaigndesigner.io/customers/bol/preview";

  // Load
  const loadTemplate = () => {
    // Get token from search string and get brickId
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const token = params.get("token");
    const brickId = params.get("brickId");
    const templateId = params.get("templateId");
    let format;

    // Request from API
    axios
      .get(api, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          brickId,
          templateId,
        },

        // If success
      })
      .then((response) => {
        let data = response.data;

        if (!format) {
          format = data?.templateData?.settings?.formats[0].key;
        }

        // Create data object
        let iframeData = {
          template: data?.templateData?.templateExport,
          ...data.assetData,
          format: format,
        };
        setSize({
          width: data?.templateData?.settings?.formats[0].width,
          height: data?.templateData?.settings?.formats[0].height,
        });
        console.log("@@response", iframeData);

        // Send message to iframe
        ifr.contentWindow.postMessage(
          { origin: window.location.origin, uuid: "preview", data: iframeData },
          "*"
        );
      });
  };

  // On component load
  React.useEffect(() => {
    loadTemplate();
  }, []);

  return (
    <div className="App" style={{ width: size.width, height: size.height }}>
      <iframe
        ref={(f) => (ifr = f)}
        title="Ad"
        frameborder="0"
        src={previewUrl}
        style={{ width: "100%", height: "100%" }}
      ></iframe>
    </div>
  );
}

export default App;
